import { ClientFileUtilities } from '@mntn-dev/files-adapter-client'
import { getClientFilesApiUrl } from './get-url.ts'

export const {
  getFileImageProxyUrl,
  getFileDownloadProxyUrl,
  saveFileToClient,
} = ClientFileUtilities(getClientFilesApiUrl())
